import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaPhoneAlt, FaTiktok } from "react-icons/fa";
import { FaFacebook, FaYoutube } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6"
import Spinner from "./Spinner";


const Topbar = () => {
    let HOME_PIC1 = require('../assets/GPPAF-LOGO.png');
    const message = "Glory And Praise Prime Academy Foundation";
    const [showMessage, setShowMessage] = useState(true);
    const [imagesLoaded, setImagesLoaded] = useState(false); // Track if images are loaded

    useEffect(() => {
        const img1 = new Image();

        img1.src = HOME_PIC1;

        const handleImageLoad = () => {
            if (img1.complete) {
                setImagesLoaded(true); // All images are loaded
            }
        };

        img1.onload = handleImageLoad;
    }, [HOME_PIC1]);

    if (!imagesLoaded) {
        return (
            <Spinner/>
        );
    }

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setShowMessage((prev) => !prev); // Toggle visibility
    //     }, 5000); // Delay between each message toggle (5 seconds)

    //     return () => clearInterval(interval); // Clear interval on component unmount
    // }, []);

    return (
        <div className="relative w-full space-y-1 md:space-y-0 bg-gray-100 text-black p-2 md:flex justify-between">
            {/* Left side with scrolling message */}
            <div className="w-full md:w-2/4 md:text-xl overflow-hidden">
                {showMessage && (
                    <div className="whitespace-nowrap flex font-bold animate-marquee">
                        <img src={ HOME_PIC1 } className=" h-10 my-auto mr-4 " alt="ACC Pic" />
                        <h2 className="my-auto">{message}</h2>
                    </div>
                )}
            </div>

            {/* Middle side with phone number */}
            <div className="w-full md:w-1/4 flex space-x-4 items-center">
                <span className="ml-2 flex md:font-semibold">
                    <FaPhoneAlt className="my-auto md:ml-4 mr-2"/> 0805 533 5170
                </span>
                <Link to="/contact"><button className="bg-yellow-500 text-white py-auto px-2 text-xl font-medium md:text-xl rounded-md hover:bg-yellow-700">Contact Us</button></Link>
            </div>

            {/* Right side with social media icons */}
            <div className="w-full md:w-1/4 mr-2 md:mr-4 flex justify-end items-center space-x-4">
                <a href="https://www.facebook.com/share/1CfCnyYDvU/?mibextid=LQQJ4d" className="text-xl">
                    <FaFacebook />
                </a>
                <a href="https://www.instagram.com/gloryandpraise1/profilecard/?igsh=MXRsZDg5dWtiaHhibQ==" className="text-xl">
                    <FaInstagram />
                </a>
                <a href="https://www.tiktok.com/@gppaf1?_t=8qCvY9MGpxl&_r=1" className="text-xl">
                    <FaTiktok />
                </a>
                <a href="https://twitter.com/gloryandpraise1" className="text-xl">
                    <FaSquareXTwitter />
                </a>
                <a href="https://www.youtube.com/channel/UCZqUadHISmghNq1bIkGaFWQ" className="text-xl">
                    <FaYoutube />
                </a>
            </div>
        </div>
    );
};

export default Topbar;
